export const ROUTES_PATH = {
  HOME: "/",
  SEARCH: "/search",
  GIFT: "/gift/:id",
  SELECT_MALL: "/select-mall",
  NEWS: "/news/:id",

  REGISTRATION: "/registration",
  ACCOUNT: "/account",
  ABOUT: "/account/about",
  STATUSES: "/account/statuses",
  MY_GIFTS: "/account/gifts",
  HISTORY: "/account/history",
  INVITE: "/account/invite",
  SUPPORT: "/account/support",
  PROFILE: "/account/profile",
  MY_GIFT: "/account/gift/:id",

  SCAN: "/scan",
};
